import { toast } from '@/components/ui';
import type { ClientFormData } from './formDataUtils';

export const handleStepNavigation = (
  currentStep: number,
  isRolesStepValid: boolean,
  formData: ClientFormData,
  validateAndShowErrorsFn: () => boolean,
  setCompletedSteps: (fn: (prev: boolean[]) => boolean[]) => void,
  setCurrentStep: (fn: (prev: number) => number) => void,
  stepsLength: number
): boolean => {
  if (currentStep === 1 && !isRolesStepValid) {
    toast.error("Please save or cancel the open role form to continue.");
    return false;
  }

  // Special structural validation for roles step, with a specific message.
  if (currentStep === 1 && (!formData.roles || formData.roles.length === 0)) {
    toast.error("Client must have at least one role.");
    return false;
  }

  if (!validateAndShowErrorsFn()) {
    return false;
  }
  
  // If validation passes
  setCompletedSteps(prev => {
    const newCompleted = [...prev];
    newCompleted[currentStep] = true;
    return newCompleted;
  });
  setCurrentStep(prev => Math.min(prev + 1, stepsLength - 1));
  return true;
};

export const handleStepBack = (
  setCurrentStep: (fn: (prev: number) => number) => void
): void => {
  setCurrentStep(prev => Math.max(prev - 1, 0));
};
